import React, { Component } from 'react';
import '../ri.scss';
import Wrapper from "../../../helpers/wrapper";
import Col from "react-bootstrap/esm/Col";
import { Breadcrumb, Container, Image, ProgressBar } from 'react-bootstrap';
import FilterBadge from '../../../shared/components/filterbadge/FilterBadge';
import StickyLogo from "../../../../assets/images/icons/icon.png";
import IconPdf from "../../../../assets/images/icons/pdfIcon";

import DatePicker from "../../../shared/components/datepicker/datepicker";
import { Carousel } from '../../../shared/components/carousel/carousel';
import { DetailsCard } from "../../../shared/components/cards/detailscard/detailscard";
import IconWebsite from '../../../../assets/images/icons/websiteIcon';
import IconFemale from "../../../../assets/images/icons/femaleIcon";
import IconMale from "../../../../assets/images/icons/maleIcon";
import HorizontalBarChart from "../../../shared/components/charts/HorizontalBarChart";
import RiTreegraph from "../../../shared/components/charts/RiTreegraph";
import Lable from 'react-bootstrap/FormLabel';
import Accordion from '../../../shared/components/accordion/Accordion';
import IconUserGroup from "../../../../assets/images/icons/usergroupIcon";
import IconAts from '../../../../assets/images/icons/atsIcon';
import IconCart from '../../../../assets/images/icons/cartIcon';
import IconTag from '../../../../assets/images/icons/tagIcon';
import IconBusinesCategory from '../../../../assets/images/icons/businesscategoryIcon';
import IconReach from "../../../../assets/images/icons/reachIcon";
import IconCategory from '../../../../assets/images/icons/categoryIcon';
import IconClose from "../../../../assets/images/icons/closeicon";
import IconFilter from '../../../../assets/images/icons/filterIcon';

import CustomerFilterMobile from './CustomerFilterMobile';

import BRAND1 from "../../../../assets/images/brands/brand1.png";
import BRAND2 from "../../../../assets/images/brands/brand2.png";
import BRAND3 from "../../../../assets/images/brands/brand3.png";
import BRAND4 from "../../../../assets/images/brands/brand4.png";
import BRAND5 from "../../../../assets/images/brands/brand5.png";
import BrandDropdown from "../../../shared/components/dropdown/brandDropdown";
import ChartExport from '../../../shared/components/export/ChartExport';


class RiCustomerFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {

            brandsDropdownOptions: [
                {
                    value: "pulsar",
                    label: "Pulsar",
                    icon: (
                        <img
                            src={BRAND1}
                            style={{ width: "25px", height: "25px", borderRadius: "100%" }}
                        />
                    ),
                },
                {
                    value: "platina",
                    label: "Platina",
                    icon: (
                        <img
                            src={BRAND2}
                            style={{ width: "25px", height: "25px", borderRadius: "100%" }}
                        />
                    ),
                },
                {
                    value: "ct",
                    label: "CT",
                    icon: (
                        <img
                            src={BRAND3}
                            style={{ width: "25px", height: "25px", borderRadius: "100%" }}
                        />
                    ),
                },
                {
                    value: "avenger",
                    label: "Avenger",
                    icon: (
                        <img
                            src={BRAND4}
                            style={{ width: "25px", height: "25px", borderRadius: "100%" }}
                        />
                    ),
                },
                {
                    value: "dominar",
                    label: "Dominar",
                    icon: (
                        <img
                            src={BRAND5}
                            style={{ width: "25px", height: "25px", borderRadius: "100%" }}
                        />
                    ),
                }
            ],

            selectedBrandDropdownOption: "",

            linesparkgraph: [{ "date": "2012-07-27", "value": 13 }, { "date": "2012-07-28", "value": 10 }, { "date": "2012-07-29", "value": 15 }, { "date": "2012-07-30", "value": 15 }, { "date": "2012-07-31", "value": 15 }, { "date": "2012-08-01", "value": 15 }, { "date": "2012-08-02", "value": 15 }, { "date": "2012-08-03", "value": 19 }, { "date": "2012-08-04", "value": 16 }, { "date": "2012-08-05", "value": 15 }, { "date": "2012-08-06", "value": 19 }, { "date": "2012-08-07", "value": 17 }, { "date": "2012-08-08", "value": 18 }],
            maleDemoData: [{ "age": "18-24", "research": "40" }, { "age": "25-36", "research": "70" }, { "age": "37-50", "research": "25" }, { "age": "50+", "research": "15" }],
            femaleDemoData: [{ "age": "18-24", "research": "75" }, { "age": "25-36", "research": "60" }, { "age": "37-50", "research": "25" }, { "age": "50+", "research": "15" }],
            entryData: [{ "hour": "12pm", "weekday": "Sunday", "value": 2990 }, { "hour": "1am", "weekday": "Sunday", "value": 2520 }, { "hour": "2am", "weekday": "Sunday", "value": 2334 }, { "hour": "3am", "weekday": "Sunday", "value": 2230 }, { "hour": "4am", "weekday": "Sunday", "value": 2325 }, { "hour": "5am", "weekday": "Sunday", "value": 2019 }, { "hour": "6am", "weekday": "Sunday", "value": 2128 }, { "hour": "7am", "weekday": "Sunday", "value": 2246 }, { "hour": "8am", "weekday": "Sunday", "value": 2421 }, { "hour": "9am", "weekday": "Sunday", "value": 2788 }, { "hour": "10am", "weekday": "Sunday", "value": 2959 }, { "hour": "11am", "weekday": "Sunday", "value": 3018 }, { "hour": "12am", "weekday": "Sunday", "value": 3154 }, { "hour": "1pm", "weekday": "Sunday", "value": 3172 }, { "hour": "2pm", "weekday": "Sunday", "value": 3368 }, { "hour": "3pm", "weekday": "Sunday", "value": 3464 }, { "hour": "4pm", "weekday": "Sunday", "value": 3746 }, { "hour": "5pm", "weekday": "Sunday", "value": 3656 }, { "hour": "6pm", "weekday": "Sunday", "value": 3336 }, { "hour": "7pm", "weekday": "Sunday", "value": 3292 }, { "hour": "8pm", "weekday": "Sunday", "value": 3269 }, { "hour": "9pm", "weekday": "Sunday", "value": 3300 }, { "hour": "10pm", "weekday": "Sunday", "value": 3403 }, { "hour": "11pm", "weekday": "Sunday", "value": 3323 }, { "hour": "12pm", "weekday": "Monday", "value": 3346 }, { "hour": "1am", "weekday": "Monday", "value": 2725 }, { "hour": "2am", "weekday": "Monday", "value": 3052 }, { "hour": "3am", "weekday": "Monday", "value": 3876 }, { "hour": "4am", "weekday": "Monday", "value": 4453 }, { "hour": "5am", "weekday": "Monday", "value": 3972 }, { "hour": "6am", "weekday": "Monday", "value": 4644 }, { "hour": "7am", "weekday": "Monday", "value": 5715 }, { "hour": "8am", "weekday": "Monday", "value": 7080 }, { "hour": "9am", "weekday": "Monday", "value": 8022 }, { "hour": "10am", "weekday": "Monday", "value": 8446 }, { "hour": "11am", "weekday": "Monday", "value": 9313 }, { "hour": "12am", "weekday": "Monday", "value": 9011 }, { "hour": "1pm", "weekday": "Monday", "value": 8508 }, { "hour": "2pm", "weekday": "Monday", "value": 8515 }, { "hour": "3pm", "weekday": "Monday", "value": 8399 }, { "hour": "4pm", "weekday": "Monday", "value": 8649 }, { "hour": "5pm", "weekday": "Monday", "value": 7869 }, { "hour": "6pm", "weekday": "Monday", "value": 6933 }, { "hour": "7pm", "weekday": "Monday", "value": 5969 }, { "hour": "8pm", "weekday": "Monday", "value": 5552 }, { "hour": "9pm", "weekday": "Monday", "value": 5434 }, { "hour": "10pm", "weekday": "Monday", "value": 5070 }, { "hour": "11pm", "weekday": "Monday", "value": 4851 }, { "hour": "12pm", "weekday": "Tuesday", "value": 4468 }, { "hour": "1am", "weekday": "Tuesday", "value": 3306 }, { "hour": "2am", "weekday": "Tuesday", "value": 3906 }, { "hour": "3am", "weekday": "Tuesday", "value": 4413 }, { "hour": "4am", "weekday": "Tuesday", "value": 4726 }, { "hour": "5am", "weekday": "Tuesday", "value": 4584 }, { "hour": "6am", "weekday": "Tuesday", "value": 5717 }, { "hour": "7am", "weekday": "Tuesday", "value": 6504 }, { "hour": "8am", "weekday": "Tuesday", "value": 8104 }, { "hour": "9am", "weekday": "Tuesday", "value": 8813 }, { "hour": "10am", "weekday": "Tuesday", "value": 9278 }, { "hour": "11am", "weekday": "Tuesday", "value": 10425 }, { "hour": "12am", "weekday": "Tuesday", "value": 10137 }, { "hour": "1pm", "weekday": "Tuesday", "value": 9290 }, { "hour": "2pm", "weekday": "Tuesday", "value": 9255 }, { "hour": "3pm", "weekday": "Tuesday", "value": 9614 }, { "hour": "4pm", "weekday": "Tuesday", "value": 9713 }, { "hour": "5pm", "weekday": "Tuesday", "value": 9667 }, { "hour": "6pm", "weekday": "Tuesday", "value": 8774 }, { "hour": "7pm", "weekday": "Tuesday", "value": 8649 }, { "hour": "8pm", "weekday": "Tuesday", "value": 9937 }, { "hour": "9pm", "weekday": "Tuesday", "value": 10286 }, { "hour": "10pm", "weekday": "Tuesday", "value": 9175 }, { "hour": "11pm", "weekday": "Tuesday", "value": 8581 }, { "hour": "12pm", "weekday": "Wednesday", "value": 8145 }, { "hour": "1am", "weekday": "Wednesday", "value": 7177 }, { "hour": "2am", "weekday": "Wednesday", "value": 5657 }, { "hour": "3am", "weekday": "Wednesday", "value": 6802 }, { "hour": "4am", "weekday": "Wednesday", "value": 8159 }, { "hour": "5am", "weekday": "Wednesday", "value": 8449 }, { "hour": "6am", "weekday": "Wednesday", "value": 9453 }, { "hour": "7am", "weekday": "Wednesday", "value": 9947 }, { "hour": "8am", "weekday": "Wednesday", "value": 11471 }, { "hour": "9am", "weekday": "Wednesday", "value": 12492 }, { "hour": "10am", "weekday": "Wednesday", "value": 9388 }, { "hour": "11am", "weekday": "Wednesday", "value": 9928 }, { "hour": "12am", "weekday": "Wednesday", "value": 9644 }, { "hour": "1pm", "weekday": "Wednesday", "value": 9034 }, { "hour": "2pm", "weekday": "Wednesday", "value": 8964 }, { "hour": "3pm", "weekday": "Wednesday", "value": 9069 }, { "hour": "4pm", "weekday": "Wednesday", "value": 8898 }, { "hour": "5pm", "weekday": "Wednesday", "value": 8322 }, { "hour": "6pm", "weekday": "Wednesday", "value": 6909 }, { "hour": "7pm", "weekday": "Wednesday", "value": 5810 }, { "hour": "8pm", "weekday": "Wednesday", "value": 5151 }, { "hour": "9pm", "weekday": "Wednesday", "value": 4911 }, { "hour": "10pm", "weekday": "Wednesday", "value": 4487 }, { "hour": "11pm", "weekday": "Wednesday", "value": 4118 }, { "hour": "12pm", "weekday": "Thursday", "value": 3689 }, { "hour": "1am", "weekday": "Thursday", "value": 3081 }, { "hour": "2am", "weekday": "Thursday", "value": 6525 }, { "hour": "3am", "weekday": "Thursday", "value": 6228 }, { "hour": "4am", "weekday": "Thursday", "value": 6917 }, { "hour": "5am", "weekday": "Thursday", "value": 6568 }, { "hour": "6am", "weekday": "Thursday", "value": 6405 }, { "hour": "7am", "weekday": "Thursday", "value": 8106 }, { "hour": "8am", "weekday": "Thursday", "value": 8542 }, { "hour": "9am", "weekday": "Thursday", "value": 8501 }, { "hour": "10am", "weekday": "Thursday", "value": 8802 }, { "hour": "11am", "weekday": "Thursday", "value": 9420 }, { "hour": "12am", "weekday": "Thursday", "value": 8966 }, { "hour": "1pm", "weekday": "Thursday", "value": 8135 }, { "hour": "2pm", "weekday": "Thursday", "value": 8224 }, { "hour": "3pm", "weekday": "Thursday", "value": 8387 }, { "hour": "4pm", "weekday": "Thursday", "value": 8218 }, { "hour": "5pm", "weekday": "Thursday", "value": 7641 }, { "hour": "6pm", "weekday": "Thursday", "value": 6469 }, { "hour": "7pm", "weekday": "Thursday", "value": 5441 }, { "hour": "8pm", "weekday": "Thursday", "value": 4952 }, { "hour": "9pm", "weekday": "Thursday", "value": 4643 }, { "hour": "10pm", "weekday": "Thursday", "value": 4393 }, { "hour": "11pm", "weekday": "Thursday", "value": 4017 }, { "hour": "12pm", "weekday": "Friday", "value": 4022 }, { "hour": "1am", "weekday": "Friday", "value": 3063 }, { "hour": "2am", "weekday": "Friday", "value": 3638 }, { "hour": "3am", "weekday": "Friday", "value": 3968 }, { "hour": "4am", "weekday": "Friday", "value": 4070 }, { "hour": "5am", "weekday": "Friday", "value": 4019 }, { "hour": "6am", "weekday": "Friday", "value": 4548 }, { "hour": "7am", "weekday": "Friday", "value": 5465 }, { "hour": "8am", "weekday": "Friday", "value": 6909 }, { "hour": "9am", "weekday": "Friday", "value": 7706 }, { "hour": "10am", "weekday": "Friday", "value": 7867 }, { "hour": "11am", "weekday": "Friday", "value": 8615 }, { "hour": "12am", "weekday": "Friday", "value": 8218 }, { "hour": "1pm", "weekday": "Friday", "value": 7604 }, { "hour": "2pm", "weekday": "Friday", "value": 7429 }, { "hour": "3pm", "weekday": "Friday", "value": 7488 }, { "hour": "4pm", "weekday": "Friday", "value": 7493 }, { "hour": "5pm", "weekday": "Friday", "value": 6998 }, { "hour": "6pm", "weekday": "Friday", "value": 5941 }, { "hour": "7pm", "weekday": "Friday", "value": 5068 }, { "hour": "8pm", "weekday": "Friday", "value": 4636 }, { "hour": "9pm", "weekday": "Friday", "value": 4241 }, { "hour": "10pm", "weekday": "Friday", "value": 3858 }, { "hour": "11pm", "weekday": "Friday", "value": 3833 }, { "hour": "12pm", "weekday": "Saturday", "value": 3503 }, { "hour": "1am", "weekday": "Saturday", "value": 2842 }, { "hour": "2am", "weekday": "Saturday", "value": 2808 }, { "hour": "3am", "weekday": "Saturday", "value": 2399 }, { "hour": "4am", "weekday": "Saturday", "value": 2280 }, { "hour": "5am", "weekday": "Saturday", "value": 2139 }, { "hour": "6am", "weekday": "Saturday", "value": 2527 }, { "hour": "7am", "weekday": "Saturday", "value": 2940 }, { "hour": "8am", "weekday": "Saturday", "value": 3066 }, { "hour": "9am", "weekday": "Saturday", "value": 3494 }, { "hour": "10am", "weekday": "Saturday", "value": 3287 }, { "hour": "11am", "weekday": "Saturday", "value": 3416 }, { "hour": "12am", "weekday": "Saturday", "value": 3432 }, { "hour": "1pm", "weekday": "Saturday", "value": 3523 }, { "hour": "2pm", "weekday": "Saturday", "value": 3542 }, { "hour": "3pm", "weekday": "Saturday", "value": 3347 }, { "hour": "4pm", "weekday": "Saturday", "value": 3292 }, { "hour": "5pm", "weekday": "Saturday", "value": 3416 }, { "hour": "6pm", "weekday": "Saturday", "value": 3131 }, { "hour": "7pm", "weekday": "Saturday", "value": 3057 }, { "hour": "8pm", "weekday": "Saturday", "value": 3227 }, { "hour": "9pm", "weekday": "Saturday", "value": 3060 }, { "hour": "10pm", "weekday": "Saturday", "value": 2855 }, { "hour": "11pm", "weekday": "Saturday", "value": 2625 }],
            personas: [{ name: 'Big Wallets', checked: false }, { name: 'Bargain Hunters', checked: false }, { name: 'Potential Loyalists', checked: false }, { name: 'Active Loyalists', checked: false }, { name: 'Hibernating', checked: false }, { name: 'Need Attention', checked: false }, { name: 'Lost', checked: false }],
            member_type: [{ name: 'BTF', checked: false }, { name: 'Non BTF', checked: false }],
            ats: [{ name: 'Low (Below Rs.1000)', checked: false }, { name: 'Medium (Rs.1000-2500)', checked: false }, { name: 'High (Rs.2500-3500)', checked: false }, { name: 'Premium (Rs.3500 & Above)', checked: false }],
            basketsize: [{ name: '1-2 Pcs', checked: false }, { name: '3-5 Pcs', checked: false }, { name: '6-10 Pcs', checked: false }, { name: 'Above 10 Pcs', checked: false }],
            busi_category: [{ name: 'Apparels', checked: false }, { name: 'Lifestyle', checked: false }, { name: 'NSM & Others', checked: false }],
            business_sub_dept_list: [
                { name: 'Accessories', checked: false },
                { name: 'Backpack', checked: false },
                { name: 'Beauty & Health', checked: false },
                { name: 'Fashion Jewellery', checked: false },
                { name: 'Footwear', checked: false },
                { name: 'Handbags', checked: false },
                { name: 'Home', checked: false },
                { name: 'Kids', checked: false },
                { name: 'Ladies Ethnic', checked: false },
                { name: 'Ladies Western', checked: false },
                { name: 'Lingerie', checked: false },
                { name: 'Luggage', checked: false },
                { name: 'Mens Casuals', checked: false },
                { name: 'Mens Formal', checked: false },
                { name: 'NSM', checked: false },
                { name: 'Sports Wear', checked: false },
                { name: 'Sunglasses', checked: false },
                { name: 'Youth', checked: false }],
            category: [{ name: 'PB', checked: false }, { name: 'FLFL', checked: false }, { name: 'Sports', checked: false }, { name: 'Luggage', checked: false }],
            city: [{ name: 'Mumbai', checked: false }, { name: 'Delhi', checked: false }, { name: 'Hyderabad', checked: false }, { name: 'Ahmedabad', checked: false }, { name: 'Kolkata', checked: false }],
            city_type: [{ name: 'Metro', checked: false }, { name: 'Non Metro', checked: false }],
            colour: [{ name: 'Black', checked: false },
            { name: 'Pink', checked: false },
            { name: 'Beige', checked: false },
            { name: 'Gold', checked: false },
            { name: 'Grey', checked: false },
            { name: 'Blue', checked: false },
            { name: 'White', checked: false },
            { name: 'Brown', checked: false },
            { name: 'Tan', checked: false },
            { name: 'Green', checked: false },
            { name: 'Navy Blue', checked: false }],
            coupon_affinity: [{ name: 'Yes', checked: false }, { name: 'No', checked: false }],
            cust_nmds: [{ name: '1 Store', checked: false }, { name: '2 Stores', checked: false }, { name: '3 Stores', checked: false }, { name: '4 Stores', checked: false }, { name: 'Abv 5 stores', checked: false }],
            customer_type: [{ name: 'New', checked: false }, { name: 'Existing', checked: false }],
            frequency: [{ name: 'Regular (1-timers)', checked: false }, { name: 'Silver (2-3)', checked: false }, { name: 'Gold (4-5)', checked: false }, { name: 'Platinum (Above 5)', checked: false }],
            gender: [{ name: 'Kids', checked: false }, { name: 'Mens', checked: false }, { name: 'Ladies', checked: false }],
            ltv_data: [{ name: '<10K', checked: false }, { name: '10k- 25k', checked: false }, { name: '25k-50k', checked: false }, { name: 'Above 50K', checked: false }],
            markdown: [{ name: '<20%', checked: false }, { name: '20%-40%', checked: false }, { name: '40%-50%', checked: false }, { name: '50%-60%', checked: false }, { name: '>60%', checked: false }],
            age: [{ name: '18-24', checked: false }, { name: '25-36', checked: false }, { name: '37-50', checked: false }, { name: '50+', checked: false }],
            brand: [{ name: '1 Up', checked: false },
            { name: '18 Fire', checked: false },
            { name: '7 Heaven', checked: false },
            { name: 'A First', checked: false },
            { name: 'A1', checked: false },
            { name: 'Aashika', checked: false },
            { name: 'Aashirvaad', checked: false },
            { name: 'Aawrun', checked: false },
            { name: 'Absolute', checked: false },
            { name: 'Action', checked: false },
            { name: 'Actuel', checked: false },
            { name: 'Add', checked: false },
            { name: 'Adda', checked: false },
            { name: 'Adda', checked: false },
            { name: 'Adler', checked: false },
            { name: 'Aerowalk', checked: false },
            { name: 'Ally Carter', checked: false },
            { name: 'Amar', checked: false },
            { name: 'Ambassador', checked: false },
            { name: 'Amber', checked: false },
            { name: 'Amkay', checked: false },
            { name: 'Aneri', checked: false },
            { name: 'Anika', checked: false },
            { name: 'Ankerites', checked: false },
            { name: 'Antonio', checked: false },
            { name: 'Anukool Apparels', checked: false },
            { name: 'Apoorva', checked: false },
            { name: 'Apsara', checked: false },
            { name: 'Archies', checked: false },
            { name: 'Artdinox', checked: false },
            { name: 'Ash Krofts', checked: false },
            { name: 'Asha Arts', checked: false },
            { name: 'Ashika', checked: false },
            { name: 'Ashirwad', checked: false },
            { name: 'Ashish', checked: false },
            { name: 'Asian', checked: false },
            { name: 'Aspen', checked: false }],

            product: ['Accessories', 'Acc Jewellery', 'Backpack', 'Bags', 'Bangles', 'Bath Robe', 'Bath Towel', 'Bed Cover', 'Belt', 'Blazer', 'Bottom Wear', 'Boxer Shorts', 'Bra', 'Bracelet', 'Brief', 'Camisol', 'Capri', 'Caps', 'Cardigans', 'Cargo', 'Character Backpack', 'Churidar', 'Clutches', 'Coordinates', 'Cosmetics', 'Cufflinks', 'Culottes', 'Curtain Tie & Ring', 'Cushion Cover', 'Cushion With Filler', 'Detergent', 'Dhoti', 'Doll Set', 'Door Curtain', 'Dorie', 'Double Bed Linen', 'Double Bed Linen Set', 'Double Blanket', 'Double Dohar', 'Double Quilt', 'Double Quilt Cover', 'Dress', 'Dress Material', 'Duffle Bags', 'Dungree', 'Dupatta', 'Earrings', 'Electronics', 'Ethnic', 'Ethnic Sets', 'Ethnic Top', 'Eyewear', 'Fabrics', 'Face Mask', 'Face Towel', 'Flat Knit', 'Footwear', 'Fragrance', 'Frock', 'Ghaghra', 'Ghagra Choli', 'Gift Pack', 'Gloves', 'Gown', 'Hand Towel', 'Handbags', 'Hankies', 'Hard Trolley', 'Hiking Bag', 'Home', 'Indoor Mat', 'Jacket', 'Jamaican', 'Jeans',
                'Jeggings', 'Joggers', 'Jumpsuit', 'Kitchen Towel', 'Knit Top', 'Kurta', 'Kurta Payjama Set', 'Kurtis', 'Ladies Bottom Wear', 'Laptop Backpack', 'Leggings', 'Lingerie', 'Lungi', 'M&M', 'Mat', 'Necklace', 'Night Suit', 'Nightwear', 'Non Operative', 'Nsm', 'Others', 'Outdoor Mat', 'Over Nighter', 'Palazzo', 'Panties', 'Pants', 'Party Wear', 'Patyala', 'Payjama', 'Pillow', 'Pillow Cover', 'Promo Zone', 'Pyjama', 'Rainwear', 'Rings', 'Romper', 'Rug', 'Sandal', 'Sandal/ Slipper', 'Sarees', 'Scarf', 'Sets', 'Shawl', 'Sherwani', 'Shirting Pcs', 'Shirts', 'Shoe Care', 'Shoe Lace', 'Shoes', 'Shorts', 'Shrug', 'Single Bed Linen Set', 'Single Blanket', 'Single Dohar', 'Single Quilt', 'Skd', 'Skirts', 'Sling Bag', 'Sling Bags', 'Slip Wear', 'Slip Wr Legwear', 'Slipper', 'Socks', 'Soft Trolley', 'Sole', 'Sports Acc', 'Sports Wear', 'Stoles', 'Suit Pc', 'Suits', 'Sunglasses', 'Sweaters', 'Swim Wear', 'Table Mat Set', 'Thermal Bottoms', 'Thermal Tops', 'Ties', 'Tights', 'Top', 'Top Wear', 'Towel', 'Toys & Inf', 'Tracks', 'Trainer', 'Travel Accessories', 'Trousers', 'Trunks', 'T-Shirts', 'Tunic', 'Ug', 'Umbrella', 'Vest', 'Waistcoat', 'Wallets', 'Warehouse', 'Watches', 'Winter Wear', 'Winter Zone', 'Woollen Kurti', 'Woven Top', 'Ww-Jacket', 'Ww-Other', 'Ww-Pullover', 'Ww-Sweat Shirts', 'Ww-Sweaters'],

            recency: [{ name: 'Active (0-6M)', checked: false }, { name: 'TY Lapsers (6-12M)', checked: false }, { name: 'LY Lapsers (12-24M)', checked: false }, { name: 'Never Active (24M+)', checked: false }],
            residing_radius: [{ name: '0-5 kms', checked: false }, { name: '5-10 kms', checked: false }, { name: '10-20 kms', checked: false }, { name: 'Above 20 Kms', checked: false }],
            season: [{ name: 'SS20', checked: false }, { name: 'AW20', checked: false }, { name: 'SS21', checked: false }, { name: 'AW21', checked: false }],
            size_list: [{ name: 'S', checked: false }, { name: 'M', checked: false }, { name: 'L', checked: false }, { name: 'XL', checked: false }, { name: 'XXL', checked: false }, { name: '3XL', checked: false }],
            stock_list: [{ name: 'Transfer', checked: false }, { name: 'MTO', checked: false }, { name: 'Red Zone', checked: false }],
            storetype: [{ name: 'New', checked: false }, { name: 'LTL', checked: false }, { name: 'Mature', checked: false }],
            stores: [{ name: 'Malad', checked: false }, { name: 'Andheri', checked: false }],
            time: [{ name: 'Morning', checked: false }, { name: 'Afternoon', checked: false }, { name: 'Evening', checked: false }, { name: 'Night', checked: false }],
            zone: [{ name: 'North', checked: false }, { name: 'South', checked: false }, { name: 'APTS', checked: false }, { name: 'East', checked: false }, { name: 'West', checked: false }],
            limit: 10,

            showMessage: false,

            first_start_date: "2022-01-24",
            first_end_date: "2022-01-30",
            second_start_date: "2022-01-17",
            second_end_date: "2022-01-23",

            isDatePickerOpen: false,
            is_scroll: false,
            filterBadge: [],
            is_customerfilter_loaded: true,

        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleCallback2 = () => {
        this.setState({ isDatePickerOpen: !this.state.isDatePickerOpen });
    };

    handleScroll = () => {
        if (window.pageYOffset > 1) {
            if (!this.state.is_scroll) {
                this.setState({ is_scroll: true });
            }
        } else {
            if (this.state.is_scroll) {
                this.setState({ is_scroll: false });
            }
        }
    };

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }


    onClickRiExport = () => {
        window.print('height=2000,width=2000')
    }


    handleClick = (event) => {
        const { name, checked } = event.target;

        this.setState((prevState) => {
            const personas = prevState.personas;
            personas[name] = checked;
            return personas;
        });
    };

    _showMessage = (bool) => {
        this.setState({
            showMessage: bool
        });
    }

    showViewMore() {
        this.setState({
            limit: this.state.limit + 200
        })
    }

    editSearchTerm = (search) => {
        // this.setState({ searchTerm: e.target.value })
        if (!search) return this.state.product;
        // return this.state.product.filter(lable => lable.toLowerCase().includes(this.state.search.toLowerCase()))

        return this.state.product.filter(label => {
            this.state.searchUpdatedProductsList = label.toLowerCase().includes(search.toLowerCase())
            // return (
            //     this.state.searchUpdatedProductsList = label.toLowerCase().includes(search.toLowerCase())
            // ),
        });

    }

    handleChange = (event) => {
        this.setState({ value: event.target.value });
    };

    handleChange(event) {
        this.setState({ age: event.target.value });
    }

    handleAgeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.age[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.age[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ ats: event.target.value });
    }

    handleAtsCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.ats[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.ats[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ basketsize: event.target.value });
    }

    handleBasketsizeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.basketsize[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.basketsize[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ brand: event.target.value });
    }

    handleBrandCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.brand[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.brand[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ busi_category: event.target.value });
    }

    handleBusinesscategoryCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.busi_category[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.busi_category[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ business_sub_dept_list: event.target.value });
    }

    handleBusinesssubdeptCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.business_sub_dept_list[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.business_sub_dept_list[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ category: event.target.value });
    }

    handleCategoryCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.category[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.category[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ city: event.target.value });
    }

    handleCityCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.city[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.city[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ city_type: event.target.value });
    }

    handleCitytypeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.city_type[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.city_type[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ city_type: event.target.value });
    }

    handleCitytypeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.city_type[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.city_type[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ colour: event.target.value });
    }

    handleCitytypeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.colour[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.colour[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ coupon_affinity: event.target.value });
    }

    handleCouponaffinityCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.coupon_affinity[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.coupon_affinity[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ cust_nmds: event.target.value });
    }

    handleCustnmdsCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.cust_nmds[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.cust_nmds[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ customer_type: event.target.value });
    }

    handleCustomertypeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.customer_type[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.customer_type[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ frequency: event.target.value });
    }

    handleFrequencyCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.frequency[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.frequency[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ gender: event.target.value });
    }

    handleGenderCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.gender[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.gender[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ ltv_data: event.target.value });
    }

    handleLtvdataCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.ltv_data[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.ltv_data[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ markdown: event.target.value });
    }

    handleMarkdownCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.markdown[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.markdown[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ member_type: event.target.value });
    }

    handleMembertypeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.member_type[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.member_type[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ recency: event.target.value });
    }

    handleRecencyCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.recency[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.recency[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ residing_radius: event.target.value });
    }

    handleResidingradiusCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.residing_radius[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.residing_radius[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ season: event.target.value });
    }

    handleSeasonCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.season[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.season[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ size_list: event.target.value });
    }

    handleSizelistCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.size_list[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.size_list[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ stock_list: event.target.value });
    }

    handleStocklistCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.stock_list[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.stock_list[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ storetype: event.target.value });
    }

    handleStoretypeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.storetype[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.storetype[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ stores: event.target.value });
    }

    handleStoresCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.stores[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.stores[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ time: event.target.value });
    }

    handleTimeCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.time[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.time[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    handleChange(event) {
        this.setState({ zone: event.target.value });
    }

    handleZoneCheckbox = event => {
        let state = this.state;
        const id = event.target.getAttribute("dataid");
        const value = event.target.value;
        const dataFilterBadgeId = event.target.getAttribute("datafilterbadgeid");
        state.zone[id].checked = event.target.checked;
        this.setState(state);

        var datafilt = { id: id, filterbadgeid: dataFilterBadgeId, value: value };
        if (event.target.checked == true) {
            this.state.filterBadge.push(datafilt);
        }
        else {
            this.state.filterBadge = this.state.filterBadge.filter(x => x.id != dataFilterBadgeId);
        }
    }

    handleFilterCallBack = (e) => {
        this.state.is_customerfilter_loaded = false;
        this.state.zone[e[0]].checked = false;
        this.state.filterBadge = this.state.filterBadge.filter(x => x.id != e[1]);
        this.state.is_customerfilter_loaded = true;
    }

    // BRAND DROPDOWN
    brandDropdownSelectionHandler = (e) => {
        if (e === null) {
            this.state.selectedBrandDropdownOption = "";
        } else {
            this.state.selectedBrandDropdownOption = e;
        }
        this.forceUpdate();
    };

    render() {
        const CarouselSettings = {
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        arrows: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        arrows: false,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 1
                    }
                }
            ]
        }

        let product = this.state.product.slice(0, this.state.limit);
        let brand = this.state.brand.slice(0, this.state.limit);
        let business_sub_dept_list = this.state.business_sub_dept_list.slice(0, this.state.limit);
        let colour = this.state.colour.slice(0, this.state.limit);
        const color = ['#000000', '#f1a9c4', '#e8e6cf', '#e5c74a', '#9fa8ab', '#0074d9', '#ffffff', '#915039', '#d2b48c', '#5eb160', '#3c4477', '#ffe5b4', '#d34b56', '#b3b3b3', '#b03060', '#eadc32', '#cc9c33', '#ede6b9', '#f2f2f2', '#3d9970', '#800080'];

        return (
            <Wrapper>
                <Container className="p-0 ri_summary_bsImport" fluid>
                    <div className="grid drawer_grid ri_summary_bsImport">
                        <div className='left_drawer col_span_1 fixed-left-grid mapRightWrapper'>
                            <div className="icz-rimapsection">
                                <div className="icz-ricustftrcnr">
                                    <div className="icz-ricustftrheader">
                                        <Col lg={12} className="w-100">
                                            <h4 className="icz-ricustfiltertitle">Filters</h4>
                                        </Col>
                                        <Col lg={12} className="icz-ricustftrbdgcnr">
                                            {this.state.filterBadge.map(item => (
                                                <FilterBadge id={item.id} filterbadgeid={item.filterbadgeid} badgename={item.value} parentCallback={this.handleFilterCallBack} />
                                            ))}
                                        </Col>
                                    </div>

                                    <div className="icz-ricustftrdatacnr">

                                        {this.state.is_customerfilter_loaded == true ?
                                            <Accordion className="accordion-cust w-100" selectedIndex={this.state.selectedIndex}
                                            >
                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Age" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.age.map((item, index) => (
                                                            <Lable key={'age_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleAgeCheckbox}
                                                                    datafilterbadgeid={'age_' + index}
                                                                    dataid={index}
                                                                    value={item.name}
                                                                />
                                                                {item.name}
                                                            </Lable>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div icon={<IconAts className="icz-ricustftratsicon" />} data-header="ATS" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.ats.map((item, index) => (
                                                            <Lable key={'ats_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleAtsCheckbox}
                                                                    datafilterbadgeid={'ats_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div icon={<IconCart className="icz-ricustftricon" />} data-header="Basket Size" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.basketsize.map((item, index) => (
                                                            <Lable key={'basketsize_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleBasketsizeCheckbox}
                                                                    datafilterbadgeid={'basketsize_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div icon={<IconTag className="icz-ricustftratsicon" />} data-header="Brands" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.brand.map((item, index) => {
                                                            return (
                                                                <Lable key={'brand_' + index} className="icz-ricustftrlbl">
                                                                    <input className="icz-rifiltercheckbox"
                                                                        type="checkbox"
                                                                        onChange={this.handleBrandCheckbox}
                                                                        datafilterbadgeid={'brand_' + index}
                                                                        dataid={index}
                                                                        value={item.name} /> {item.name}</Lable>
                                                            )
                                                        })}
                                                        <a className="icz-link" onClick={this.showViewMore.bind(this)}>+ more</a>
                                                    </div>
                                                </div>

                                                <div icon={<IconBusinesCategory className="icz-ricustftratsicon" />} data-header="Business Category" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.busi_category.map((item, index) => (
                                                            <Lable key={'busi_category_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleBusinesscategoryCheckbox}
                                                                    datafilterbadgeid={'busi_category_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div icon={<IconReach className="icz-ricustftricon" />} data-header="Business Sub Department" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.business_sub_dept_list.map((item, index) => {
                                                            return (
                                                                <Lable key={'business_sub_dept_list_' + index} className="icz-ricustftrlbl">
                                                                    <input className="icz-rifiltercheckbox"
                                                                        type="checkbox"
                                                                        onChange={this.handleBusinesssubdeptCheckbox}
                                                                        datafilterbadgeid={'business_sub_dept_list_' + index}
                                                                        dataid={index}
                                                                        value={item.name} /> {item.name}</Lable>
                                                            )
                                                        })}
                                                        <a className="icz-link" onClick={this.showViewMore.bind(this)}>+ more</a>
                                                    </div>
                                                </div>

                                                <div icon={<IconCategory className="icz-ricustftratsicon" />} data-header="Category" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.category.map((item, index) => (
                                                            <Lable key={'category_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleCategoryCheckbox}
                                                                    datafilterbadgeid={'category_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="City" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.city.map((item, index) => (
                                                            <Lable key={'city_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleCityCheckbox}
                                                                    datafilterbadgeid={'city_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="City Type" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.city_type.map((item, index) => (
                                                            <Lable key={'city_type_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleCitytypeCheckbox}
                                                                    datafilterbadgeid={'city_type_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Colour" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.colour.map((item, index) => {
                                                            return (
                                                                <Lable key={'colour_' + index} className="icz-ricustftrlbl">
                                                                    <input className="icz-rifiltercheckbox"
                                                                        type="checkbox"
                                                                        onChange={this.handleColourCheckbox}
                                                                        datafilterbadgeid={'colour_' + index}
                                                                        dataid={index}
                                                                        value={item.name} /> {item.name}</Lable>
                                                            )
                                                        })}

                                                        <a className="icz-link" onClick={this.showViewMore.bind(this)}>+ more</a>
                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Coupon Affinity" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.coupon_affinity.map((item, index) => (
                                                            <Lable key={'coupon_affinity_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="radio"
                                                                    onChange={this.handleCouponaffinityCheckbox}
                                                                    datafilterbadgeid={'coupon_affinity_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}
                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Customer Nomads" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.cust_nmds.map((item, index) => (
                                                            <Lable key={'cust_nmds_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleCustnmdsCheckbox}
                                                                    datafilterbadgeid={'cust_nmds_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Customer Type" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.customer_type.map((item, index) => (
                                                            <Lable key={'customer_type_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleCustomertypeCheckbox}
                                                                    datafilterbadgeid={'customer_type_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Frequency" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.frequency.map((item, index) => (
                                                            <Lable key={'frequency_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleFrequencyCheckbox}
                                                                    datafilterbadgeid={'frequency_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Gender" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.gender.map((item, index) => (
                                                            <Lable key={'gender_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleGenderCheckbox}
                                                                    datafilterbadgeid={'gender_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="LTV" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.ltv_data.map((item, index) => (
                                                            <Lable key={'ltv_data_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleLtvdataCheckbox}
                                                                    datafilterbadgeid={'ltv_data_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Markdown" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.markdown.map((item, index) => (
                                                            <Lable key={'markdown_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleMarkdownCheckbox}
                                                                    datafilterbadgeid={'markdown_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Member Type" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.member_type.map((item, index) => (
                                                            <Lable key={'member_type_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleMembertypeCheckbox}
                                                                    datafilterbadgeid={'member_type_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Product" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {product.map((product, i) => {
                                                            return (
                                                                <Lable key={i} className="icz-ricustftrlbl"><input className="icz-rifiltercheckbox" type="checkbox" value={product} /> {product} </Lable>
                                                            )
                                                        })}
                                                        <a className="icz-link" onClick={this.showViewMore.bind(this)}>+ more</a>
                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Recency" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.recency.map((item, index) => (
                                                            <Lable key={'recency_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleRecencyCheckbox}
                                                                    datafilterbadgeid={'recency_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Residing Radius" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.residing_radius.map((item, index) => (
                                                            <Lable key={'residing_radius_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleResidingradiusCheckbox}
                                                                    datafilterbadgeid={'residing_radius_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Season" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.season.map((item, index) => (
                                                            <Lable key={'season_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleSeasonCheckbox}
                                                                    datafilterbadgeid={'season_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Size" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.size_list.map((item, index) => (
                                                            <Lable key={'size_list_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleSizelistCheckbox}
                                                                    datafilterbadgeid={'size_list_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Stock Type" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.stock_list.map((item, index) => (
                                                            <Lable key={'stock_list_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleStocklistCheckbox}
                                                                    datafilterbadgeid={'stock_list_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Store Type" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.storetype.map((item, index) => (
                                                            <Lable key={'storetype_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleStoretypeCheckbox}
                                                                    datafilterbadgeid={'storetype_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Stores" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.stores.map((item, index) => (
                                                            <Lable key={'stores_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleStoresCheckbox}
                                                                    datafilterbadgeid={'stores_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Time" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.time.map((item, index) => (
                                                            <Lable key={'time_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleTimeCheckbox}
                                                                    datafilterbadgeid={'time_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>

                                                <div icon={<IconUserGroup className="icz-ricustftricon" />} data-header="Zone" className="accordion-cust-item">
                                                    <div className="icz-ricustftrdata">
                                                        {this.state.zone.map((item, index) => (
                                                            <Lable key={'zone_' + index}
                                                                className="icz-ricustftrlbl">
                                                                <input className="icz-rifiltercheckbox"
                                                                    type="checkbox"
                                                                    onChange={this.handleTimeCheckbox}
                                                                    datafilterbadgeid={'zone_' + index}
                                                                    dataid={index}
                                                                    value={item.name} /> {item.name}</Lable>
                                                        ))}

                                                    </div>
                                                </div>
                                            </Accordion>
                                            :
                                            ''
                                        }
                                    </div>

                                    <div className="icz-ricustftrbtncnr">
                                        <button className="icz-btnfilterclear">Clear</button>
                                        <button className="icz-btnfilterapply">Apply</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="right_side col_span_3 relative-right-grid icz-ridatacontainer" style={{ padding: "0 20px" }}>
                            <Container className={'icz-section-padding icz-pageheaderwrapper'} fluid>
                                <div className="icz-pageheadercontainer">
                                    <div className="icz-stickylogowrapper">
                                        <Image src={StickyLogo} className="icz-stickylogo" />
                                    </div>
                                    <div className="p-0 icz-headerdetails d-flex justify-content-between">
                                        <Col lg={4} xs={12} md={12} className="p-0">
                                            <h2 className="icz-pagetitle">Target Group</h2>
                                        </Col>

                                        <Col lg={8} xs={12} md={12} className="p-0 icz-pagefiltersection">

                                            {/* <BrandDropdown
                                                className={"brand_dropdown"}
                                                placeholder={"Select Brand"}
                                                options={this.state.brandsDropdownOptions}
                                                ismulti={true}
                                                isClearable={true}
                                                value={this.state.selectedBrandDropdownOption}
                                                selectedOptions={this.state.selectedBrandDropdownOption}
                                                setStatedropdown={this.brandDropdownSelectionHandler}
                                            />

                                            <DatePicker
                                                parentCallback={this.handleCallback}
                                                open={this.state.isDatePickerOpen}
                                                startDate={this.state.first_start_date}
                                                endDate={this.state.first_end_date}
                                                lastStartDate={this.state.second_start_date}
                                                lastEndDate={this.state.second_end_date}
                                                setOpen={this.handleCallback2}
                                            /> */}

                                            <CustomerFilterMobile />

                                            {/* <div className="icz-btnwrapper">
                                                <button className="icz-themebtn" onClick={() => this.onClickRiExport()}>
                                                    <IconPdf className="icz-ribtnicon" />{" "}
                                                </button>
                                            </div> */}
                                        </Col>
                                    </div>
                                </div>
                            </Container>

                            <Col lg={12}>
                                <div className="grid grid_cols_1 icz-datacontainer">
                                    <div className="grid icz-carouselcontainer">
                                        <Carousel
                                            Settings={CarouselSettings}
                                            class={"icz-cardcontainer"}
                                            SliderCards={[
                                                <DetailsCard
                                                    index="1"
                                                    CardClass="icz-cardwrapper"
                                                    CardIcon={<IconWebsite className="icz-icon" />}
                                                    CardTitle="No. of Customers"
                                                    RowOneCurrentValue="100000"
                                                    RowOnePreviousValue="97800"
                                                    RowOneTitle="Mix"
                                                // IsNumber={'money'}
                                                />,

                                                <DetailsCard
                                                    index="1"
                                                    CardClass="icz-cardwrapper"
                                                    CardIcon={<IconWebsite className="icz-icon" />}
                                                    CardTitle="Total Sales"
                                                    RowOneCurrentValue="124900000"
                                                    RowOnePreviousValue="100000000"
                                                    RowOneTitle="Mix"
                                                    IsNumber={'money'}
                                                />,
                                                <DetailsCard
                                                    index="1"
                                                    CardClass="icz-cardwrapper"
                                                    CardIcon={<IconWebsite className="icz-icon" />}
                                                    CardTitle="Bills"
                                                    RowOneCurrentValue="50000"
                                                    RowOnePreviousValue="60000"
                                                    RowOneTitle="Mix"
                                                    IsNumber={'money'}
                                                />,
                                                <DetailsCard
                                                    index="1"
                                                    CardClass="icz-cardwrapper"
                                                    CardIcon={<IconWebsite className="icz-icon" />}
                                                    CardTitle="ATS"
                                                    RowOneCurrentValue="2500"
                                                    RowOnePreviousValue="2000"
                                                    RowOneTitle="Mix"
                                                // IsNumber={'money'}
                                                />
                                            ]}>

                                        </Carousel>
                                    </div>

                                    <div className="grid icz-row">
                                        <Col className="icz-sectioncardwrapper" xs={12} lg={12}>
                                            <div className="icz-sectioncard d-flex flex-row flex-wrap">
                                                <Col sm={12} className="icz-cardheader">
                                                    <Col className="icz-cardtitle">
                                                        Audience Demographics
                                                    </Col>
                                                    <Col className="icz-cardfilter">
                                                        <ChartExport
                                                            ChartId='Audience Demographics'
                                                            downloadName="Audience Demographics"
                                                            export_data={this.state.maleDemoData}
                                                        />
                                                        {/* <Dropdown dropdown_options={this.state.dropdown_options} dropdown_placeholder="Followers"  parentCallback={this.handleCallback}/> */}
                                                    </Col>
                                                </Col>
                                                <Col sm={12} lg={6} className="d-flex flex-column align-items-start">
                                                    <div className="icz-cardheader d-flex flex-column align-items-start">
                                                        <div className="icz-cardtitle">
                                                            Male
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-row flex-wrap w-100">
                                                        <Col xs={12} lg={3} className="d-flex flex-column justify-center align-items-center">
                                                            <IconMale className="icz-audienceicon" percentage={"60%"} />
                                                            <div className="icz-cardheader d-flex flex-column align-items-center">
                                                                <div className="icz-sectiontitle">
                                                                    60%
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} lg={7} className="">
                                                            <HorizontalBarChart chart_id="male_demographic" chart_class="icz-sectionchart" graph-data={this.state.maleDemoData} bar_color={"#11A1FD"} />
                                                        </Col>
                                                    </div>
                                                </Col>
                                                <Col sm={12} lg={6} className="d-flex flex-column align-items-start">
                                                    <div className="icz-cardheader d-flex flex-column align-items-start">
                                                        <div className="icz-cardtitle">
                                                            Female
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-row flex-wrap w-100">
                                                        <Col xs={3} className="d-flex flex-column justify-center align-items-center">
                                                            <IconFemale className="icz-audienceicon" percentage={"40%"} />
                                                            <div className="icz-cardheader d-flex flex-column align-items-center">
                                                                <div className="icz-sectiontitle">
                                                                    40%
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={8} className="">
                                                            <HorizontalBarChart chart_id="female_demographic" chart_class="icz-sectionchart" graph-data={this.state.femaleDemoData} bar_color={"#FF9931"} />
                                                        </Col>
                                                    </div>
                                                </Col>
                                            </div>
                                        </Col>
                                    </div>

                                    {/* <div className="grid icz-row">
                                        <div className="icz-sectioncardwrapper w-100">
                                            <div className="icz-sectioncard">
                                                <Col sm={12} className="icz-cardheader">
                                                    <Col className="icz-cardtitle">
                                                        Category Share
                                                    </Col>
                                                    <Col className="icz-cardfilter">
                                                        {/* <Dropdown dropdown_options={this.state.dropdown_options} dropdown_placeholder="Popular" parentCallback={this.handleCallback} /> *
                                                    </Col>
                                                </Col>
                                                <div className="">
                                                    {/* <RiTreegraph card_id="icz-treemap" card_class="icz-sectionchart" graph-data={this.state.customer_treegraph} /> *
                                                </div>

                                                <div>
                                                    <Col lg={12} className="icz-ridatabullet">
                                                        <ul className="icz-ridatalist-inline">
                                                            <li>Area = Units</li>
                                                            <li><div className="icz-ridatalist-bullet5" /> High NSV </li>
                                                            <li><div className="icz-ridatalist-bullet2" /> Med NSV </li>
                                                            <li><div className="icz-ridatalist-bullet6" /> Low NSV </li>
                                                        </ul>
                                                    </Col>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </Col>

                        </div>
                    </div>
                </Container>
            </Wrapper>
        );
    }
}

export default RiCustomerFilter;